import { useCallback } from 'react';
import { EditorState } from 'draft-js';
import { insertAutocompleteSuggestion } from '../utils/autocompleteUtils';


interface AutocompleteState {
  handleSuggestionSelect: (suggestion: string, editorState: EditorState, setEditorState: (state: EditorState) => void) => void;
}


/**
 * Custom hook to manage autocomplete state and suggestion selection
 */
export const useAutocomplete = (): AutocompleteState => {
  const handleSuggestionSelect = useCallback((
    suggestion: string,
    editorState: EditorState,
    setEditorState: (state: EditorState) => void
  ): void => {
    const newEditorState = insertAutocompleteSuggestion(editorState, suggestion);
    setEditorState(newEditorState);
  }, []);


  return {
    handleSuggestionSelect
  };
};